module.exports = __webpack_public_path__ + "99a30b228e440319316d04e232aa3fa9.svg";